import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const refreshUser = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch (e) {
      setUser(false);
      return false;
    }
  }, []);

  useEffect(() => {
    refreshUser();
  }, [refreshUser]);

  const value = useMemo(() => {
    const handleAuth = (data) => {
      localStorage.setItem("bt_token", data.token);
      setUser(data.user);
      return data.user;
    };
    return {
      user,
      refreshUser,
      isMember: !!user && (user.role === "admin" || user.is_member),
      login: async (email, password) => handleAuth((await api.post("/auth/login", { email, password })).data),
      testMemberLogin: async () => handleAuth((await api.post("/admin/test-member-login")).data),
      register: async (payload) => handleAuth((await api.post("/auth/register", payload)).data),
      logout: async () => {
        await api.post("/auth/logout").catch(() => {});
        localStorage.removeItem("bt_token");
        setUser(false);
      },
    };
  }, [user, refreshUser]);

  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}
